module.exports = __webpack_public_path__ + "media/application/images/flags/fr-32-5cf9be5271cfa19c9cc3d2af3ce7599a.png";